<template>
  <v-card>
    <v-card>
      <v-card-title class="grey lighten-5 headline">
        Validação de Imagens Anexadas
      </v-card-title>
      <v-row class="pa-4" justify="space-between">
        <v-col cols="3">
          <h5>Dados da Entidade</h5>
          <v-divider></v-divider>
          <v-form>
            <v-container>
              <div v-if="entidade.grupoID !== 0">
                <v-row
                  v-for="prop in entidade.entidadePropriedades"
                  :key="prop.grupoPropriedadeID"
                >
                  <v-col>
                    <v-text-field
                      :label="prop.nome"
                      v-model="prop.valor"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-form>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col cols="3">
          <h5>Documentos Vinculados</h5>
          <v-divider></v-divider>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="(doc, index) in documentos"
                  :key="doc.id"
                  style="cursor: pointer"
                  :class="{ secondary: doc.selected }"
                  @click="selecionar(index)"
                >
                  <td>{{ doc.nome }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col>
          <h5>Imagens para Aprovação</h5>
          <v-divider></v-divider>
          <v-carousel light height="450">
            <v-carousel-item v-for="img in imagens" :key="img.id">
              <v-btn
                title="Download"
                color="success"
                small
                dark
                @click="downloadImagem(img.caminhoVisualizacao)"
              >
                <v-icon small>fa fa-download</v-icon>
              </v-btn>

              <v-btn
                class="ml-2"
                title="Exibir imagem"
                color="primary"
                small
                dark
                @click="exibirImagem(img.caminhoVisualizacao)"
              >
                <v-icon small>fas fa-external-link-square-alt</v-icon>
              </v-btn>

              <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center">
                  <img
                    :src="img.caminhoVisualizacao"
                    style="max-width: 75%; max-height: 150px"
                  />
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>

          <v-divider></v-divider>

          <v-row>
            <v-col style="text-align: center">
              <v-chip color="warning" v-if="documentoSelecionado.status === 3">
                Aguardando Validação
              </v-chip>
              <v-chip color="warning" v-if="documentoSelecionado.status === 2">
                Aguardando Arquivos
              </v-chip>
              <v-chip color="success" v-if="documentoSelecionado.status === 1">
                Aprovado
              </v-chip>
              <v-chip color="error" v-if="documentoSelecionado.status === 0">
                Reprovado
              </v-chip>
            </v-col>
          </v-row>

          <v-row
            v-if="
              documentoSelecionado.status === 3 ||
              documentoSelecionado.status === 4
            "
          >
            <v-col>
              <v-textarea
                label="Observações"
                rows="1"
                v-model="arquivoValidacao.observacoes"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row
            v-if="
              documentoSelecionado.status === 3 ||
              documentoSelecionado.status === 4
            "
          >
            <v-col>
              <v-btn
                color="error"
                small
                dark
                style="float: right"
                @click="reprovar()"
                ><v-icon small>fas fa-times</v-icon
                ><span class="ml-2">Reprovar</span></v-btn
              >
            </v-col>
            <v-col
              ><v-btn color="success" small dark @click="aprovar()"
                ><v-icon small>fas fa-check</v-icon
                ><span class="ml-2">Aprovar</span></v-btn
              ></v-col
            >
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="downloadImagem(urlCaminhoExibir)">
              Salvar
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row class="mt-2" justify="center">
          <img :src="urlCaminhoExibir" />
        </v-row>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";

export default {
  name: "upload",
  data() {
    return {
      urlCaminhoExibir: null,
      dialog: false,
      empresas: [],
      grupos: [],
      documentos: [],
      entidade: {
        id: 0,
        empresaID: 0,
        grupoID: 0,
        entidadePropriedades: [],
      },
      imagens: [],
      arquivoValidacao: {
        entidadeID: 0,
        documentoID: 0,
        validado: false,
        observacoes: "",
      },
      documentoSelecionado: {},
    };
  },
  methods: {
    downloadImagem(url) {
      window.open(url);
    },

    exibirImagem(url) {
      if (!url) {
        this.dialog = false;
        return;
      }

      this.urlCaminhoExibir = url;
      this.dialog = true;
    },

    listaEmpresas() {
      return new Promise((resolve) => {
        ApiService.get("empresa/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success) this.empresas = data.data;
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    listaGrupos() {
      return new Promise((resolve) => {
        ApiService.get("grupo/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success) this.grupos = data.data;
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    listaDocumentos() {
      return new Promise((resolve) => {
        ApiService.get("documento/getbyentidadeid/" + this.entidade.id).then(
          ({ data }) => {
            if (data.success) {
              resolve(data);
              if (data.data.length > 0) {
                data.data.forEach((x) => {
                  this.documentos.push({
                    id: x.documento.id,
                    nome: x.documento.nome,
                    status: x.registro.status,
                    selected: false,
                  });
                });

                this.selecionar(0);
              }
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    listaGrupoPropriedades() {
      return new Promise((resolve) => {
        ApiService.get(
          "grupopropriedade/getbygrupoid/" + this.entidade.grupoID
        ).then(({ data }) => {
          if (data.success) {
            resolve(data);

            this.entidade.entidadePropriedades = [];

            data.data.forEach((x) => {
              this.entidade.entidadePropriedades.push({
                entidadeID: 0,
                grupoPropriedadeID: x.id,
                nome: x.nome,
                valor: "",
              });
            });
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    buscarEntidade(id) {
      return new Promise((resolve) => {
        ApiService.get("entidade/getbyid/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);

            this.entidade = data.data;
            this.arquivoValidacao.entidadeID = this.entidade.id;
            this.listaDocumentos();
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    selecionar(index) {
      this.documentos.forEach((doc) => (doc.selected = false));
      this.documentos[index].selected = true;
      this.documentoSelecionado = this.documentos[index];
      this.arquivoValidacao.documentoID = this.documentos[index].id;

      return new Promise((resolve) => {
        ApiService.get(
          "registroimagem/getbyentidadedocumentoid/" +
            this.entidade.id +
            "/" +
            this.documentos[index].id
        ).then(({ data }) => {
          resolve(data);
          if (data.success) this.imagens = data.data;
          else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    reprovar() {
      let self = this;
      this.arquivoValidacao.validado = false;

      Swal.fire({
        title: "Tem certeza que deseja REPROVAR esse Documento?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode REPROVAR!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("arquivo/validar/", self.arquivoValidacao).then(
              ({ data }) => {
                resolve(data);
                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Reprovado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          });
        }
      });
    },

    aprovar() {
      let self = this;
      this.arquivoValidacao.validado = true;

      Swal.fire({
        title: "Tem certeza que deseja APROVAR esse Documento?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode APROVAR!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("arquivo/validar/", self.arquivoValidacao).then(
              ({ data }) => {
                resolve(data);

                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Aprovador com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          });
        }
      });
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));

    this.listaEmpresas();
    this.listaGrupos();

    if (this.$route.params.entidadeid !== undefined)
      this.buscarEntidade(this.$route.params.entidadeid);
  },
};
</script>
